<template>
  <div id="app-user-personal-body" v-if="loaded">
    <!-- 标题 -->
    <div id="app-user-personal-title">
      <h1 id="app-user-personal-title-h">账号信息</h1>
      <el-button class="app-user-personal-content-button" v-on:click="openChangeNameDig">
        修改信息
      </el-button>
    </div>
    <!-- 主体内容 -->
    <div id="app-user-personal-content-body">
      <div class="app-user-personal-content">
        <div class="app-user-personal-content-name">昵称</div>
        <div class="app-user-personal-content-detail">{{ this.$store.state.userInfo.account }}</div>
      </div>
      <div class="app-user-personal-content">
        <div class="app-user-personal-content-name">邮箱</div>
        <div class="app-user-personal-content-detail">{{ this.$store.state.userInfo.mail }}</div>
      </div>
      <div class="app-user-personal-content">
        <div class="app-user-personal-content-name">电话</div>
        <div class="app-user-personal-content-detail">{{ this.$store.state.userInfo.phone }}</div>
      </div>
      <div class="app-user-personal-content">
        <div class="app-user-personal-content-name">加入时间</div>
        <div class="app-user-personal-content-detail">{{ this.$store.state.userInfo.createTime }}</div>
      </div>
      <div class="app-user-personal-content">
        <div class="app-user-personal-content-name">上次登录的IP</div>
        <div class="app-user-personal-content-detail">0.0.0.0</div>
      </div>
    </div>
    <!-- 弹出框 -->
    <ChangeUserName ref="ChangeName"></ChangeUserName>
  </div>
</template>

<script>

import ChangeUserName from "@/views/user/center/personalInfo/ChangeAccount";

import store from "@/components/dataStore";
import axiosBase from "@/components/axiosBase";
import dataStorePersisted from "@/components/dataStorePersisted";

export default {
  name: "PersonalInfo",
  store,
  components: {
    ChangeUserName
  },
  data() {
    return {
      loaded: false
    }
  },
  beforeCreate() {
    this.$parent.loaded = false;
    this.loaded = false;
    axiosBase.axiosGet("/user/info", "").then(response => {
      if (response !== 0) {
        this.$store.commit("userInfoReceive", response.data);
        this.$parent.loaded = true;
        this.loaded = true;
      } else {
        dataStorePersisted.state.isLogin = false;
      }
    })
  },
  methods: {
    openChangeNameDig() {
      this.$refs.ChangeName.dialogFormVisible = true
    }
  }
}
</script>

<style scoped>

#app-user-personal-body {
  /*border: 1px solid #000000;*/
  padding: 25px;
}

#app-user-personal-title {
  padding-bottom: 25px;
  border-bottom: 1px solid rgba(20, 20, 20, 0.2);
}

#app-user-personal-title-h {
  font-size: 16px;
}

#app-user-personal-content-body {
  position: relative;
  padding-top: 25px;
  padding-left: 10px;
}

.app-user-personal-content {
  position: relative;
  margin-left: 25px;
  margin-top: 25px;
  height: 61px;
}

.app-user-personal-content-name {
  height: 60px;
  width: 120px;
  line-height: 60px;
  text-align: center;
  float: left;
  background: rgba(20, 20, 20, 0.1);
}

.app-user-personal-content-detail {
  position: relative;
  top: 0;
  left: 0;
  height: 60px;
  width: 640px;
  border-bottom: 1px solid rgba(20, 20, 20, 0.2);
  text-align: left;
  line-height: 60px;
  padding-left: 150px;
}

.app-user-personal-content-button {
  position: absolute;
  right: 50px;
  top: 17px;
  border: 0;
  border-radius: 0 !important;
  background: #FF8A00;
  color: #FFFFFF;
}

.app-user-personal-content-button:hover {
  transition: all 350ms ease-out;
  background: #00aa55;
  /*color: #FF8A00;*/
}

</style>